import { KAKO_COIN_IMG } from '../oil/OilIcons';

export { KAKO_COIN_IMG };

/* moeda amarela — a mesma arte da seleção de pacotes da loja */
export const GbCoin = ({ className = '' }) => (
  <img src={KAKO_COIN_IMG} alt="moedas amarelas" data-testid="gb-coin-icon"
    className={`inline-block h-[1.25em] w-auto align-[-0.25em] ${className}`} />
);
